export default __webpack_public_path__ + "static/media/RightArrow.bf7f1006.svg";